const DEFAULT_ORIGIN = 'https://capquest.io';

export const getPublicSiteOrigin = (): string => {
  const fromEnv = process.env.REACT_APP_PUBLIC_SITE_ORIGIN?.replace(/\/$/, '');
  if (fromEnv) {
    return fromEnv;
  }

  if (typeof navigator !== 'undefined' && /ReactSnap/i.test(navigator.userAgent)) {
    return DEFAULT_ORIGIN;
  }

  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }

  return DEFAULT_ORIGIN;
};
